(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/horse-profile-list.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/horse-profile-list.js');

'use strict';

const {
  useRef,
  useEffect
} = React;
const {
  HorseProfile
} = svs.racing_game.components.statistics;
const isMobile = svs.core.detect.formfactor.mobile();
const HorseProfileList = _ref => {
  let {
    participants,
    selectedParticipant
  } = _ref;
  const silksFormattedDate = svs.utils.ns.isNamespace('svs.racing_game.data.race.meeting.silksFormattedDate') ? svs.racing_game.data.race.meeting.silksFormattedDate : '';
  const profileRef = useRef(null);

  const scrollTo = 222 + 6;
  useEffect(() => {
    if (isMobile && selectedParticipant) {
      const index = participants.findIndex(element => element.participantId === selectedParticipant.participantId);
      profileRef.current.scrollTo({
        behavior: 'smooth',
        left: index * scrollTo
      });
    }
  }, [selectedParticipant]);
  const profiles = participants.map(participant => React.createElement(HorseProfile, {
    isSelected: (selectedParticipant && selectedParticipant.participantId) === participant.participantId,
    key: "".concat(participant.participantId),
    participant: participant,
    silksFormattedDate: silksFormattedDate
  }));
  return React.createElement("div", {
    className: "horse-profile-list",
    ref: profileRef
  }, profiles);
};
svs.racing_game.components.statistics.HorseProfileList = HorseProfileList;

 })(window);